import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { FAQS } from "@/data/faq";
import { useLocalize } from "@/data/localize";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SEO } from "@/lib/seo";
import { CLINIC_PHONE } from "@/lib/mailto";

export default function FaqPage() {
    const { t } = useTranslation();
    const { localizeList } = useLocalize();
    const faqs = localizeList(FAQS);
    return (
        <>
            <SEO title={t("faq.seoTitle")} description={t("faq.seoDescription")} />
            <div className="container-page pt-8">
                <Breadcrumbs items={[{ label: t("faq.crumb") }]} />
            </div>
            <section className="container-page pt-6 pb-4">
                <div className="max-w-3xl">
                    <span className="chip-teal">{t("faq.chip")}</span>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--brand-navy)] leading-tight">
                        {t("faq.title")}
                    </h1>
                    <p className="mt-4 text-[color:var(--text-muted)] leading-relaxed text-lg">
                        <Trans
                            i18nKey="faq.intro"
                            values={{ phone: CLINIC_PHONE }}
                            components={{
                                1: (
                                    <a
                                        href={`tel:${CLINIC_PHONE.replace(/[^\d+]/g, "")}`}
                                        className="text-[color:var(--brand-teal-2)] font-semibold"
                                    />
                                ),
                            }}
                        />
                    </p>
                </div>
            </section>
            <section className="container-page pb-6">
                <div className="max-w-3xl">
                    <Accordion type="multiple" data-testid="faq-accordion">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                className="mb-3 rounded-xl border border-[color:var(--border-default)] bg-white px-4"
                            >
                                <AccordionTrigger className="text-left py-4 text-[color:var(--brand-navy)] font-semibold hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-4 text-[color:var(--text-muted)] leading-[1.75]">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </section>
        </>
    );
}
